type GalleryPaginationProps = {
  page: number;
  totalPages: number;
  isPending: boolean;
  rangeLabel: string;
  onPageChange: (updater: (page: number) => number) => void;
};

export function GalleryPagination({
  page,
  totalPages,
  isPending,
  rangeLabel,
  onPageChange,
}: GalleryPaginationProps) {
  return (
    <div className="flex flex-col gap-3 border-t border-[var(--dash-line)] pt-4 sm:flex-row sm:items-center sm:justify-between">
      <p className="m-0 text-xs text-[var(--dash-muted)]">{rangeLabel}</p>
      <div className="flex items-center gap-2">
        <button
          type="button"
          disabled={page <= 1 || isPending}
          onClick={() => onPageChange((p) => p - 1)}
          className="rounded-xl border border-[var(--dash-line)] bg-white px-3 py-2 text-xs font-semibold text-[var(--dash-ink)] disabled:opacity-40"
        >
          Previous
        </button>
        <span className="text-xs font-semibold text-[var(--dash-muted)]">
          {page} / {totalPages}
        </span>
        <button
          type="button"
          disabled={page >= totalPages || isPending}
          onClick={() => onPageChange((p) => p + 1)}
          className="rounded-xl border border-[var(--dash-line)] bg-white px-3 py-2 text-xs font-semibold text-[var(--dash-ink)] disabled:opacity-40"
        >
          Next
        </button>
      </div>
    </div>
  );
}
